import React from 'react';
import { Link } from "react-router-dom";
import { Container, Row, Col } from 'react-bootstrap'
import { IconBrandFacebook, IconBrandX, IconBrandInstagram, IconBrandLinkedin, IconBrandTiktok } from '@tabler/icons-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <>
      <footer id='footer'>
        <div className="footer-top">
          <Container>
            <Row>
              <Col lg={3} sm={6} className='order-lg-1 order-sm-1 mb-lg-0 mb-4'>
                <div className="foot topper">
                  <Link to="/home" className="navbar-brand"><img src="../Images/myfx-logo-new.png" alt="" /></Link>
                  <strong>Your trusted partner for <br/>international financial solutions.</strong>
                  <ul className='social'>
                    <li><Link to="https://www.tiktok.com/@www_myfx.ca?_t=ZM-8spHB8yIQ0k&_r=1" target='_blank'><IconBrandTiktok size={40} stroke={1} /></Link></li>
                    <li><Link to="https://www.facebook.com/profile.php?id=100063887240664&mibextid=ZbWKwL" target='_blank'><IconBrandFacebook size={40} stroke={1} /></Link></li>
                    <li><Link to="https://www.instagram.com/myfx.ca?igsh=NWc0emxybG0ybHB1" target='_blank'><IconBrandInstagram size={40} stroke={1} /></Link></li>
                  </ul>
                </div>
              </Col>
              <Col lg={3} sm={6} className='order-lg-2 order-sm-3 mb-lg-0 mb-4'>
                <div className="foot">
                  <h5>Quick <span>Links</span></h5>
                  <ul>
                    <li><Link to="/home">Home</Link></li>
                    <li><Link to="/about">About Us</Link></li>
                    <li><Link to="/services">Our Services</Link></li>
                    <li><Link to="/contact">Contact</Link></li>
                  </ul>
                </div>
              </Col>
              <Col lg={3} sm={6} className='order-lg-3 order-sm-2 mb-lg-0 mb-4'>
                <div className="foot">
                  <h5>Our <span>Services</span></h5>
                  <ul>
                    <li><Link to="/effortlessglobalpayments">Effortless Global Payments</Link></li>
                    <li><Link to="/applyforletterofcredit">Apply for Letter of Credit (LC)</Link></li>
                    <li><Link to="/tuitionpaymentsforcanada">Tuition Payments for Canada</Link></li>
                    <li><Link to="/realestateinvestmentpayments">Real Estate Investment Payments</Link></li>
                  </ul>
                </div>
              </Col>
              <Col lg={3} sm={6} className='order-lg-4 order-sm-4 mb-lg-0 mb-0'>
                <div className="foot">
                  <h5>Further <span>Links</span></h5>
                  <ul>
                    <li><Link to="/privacypolicy">Privacy Policy</Link></li>
                    <li><Link to="/termsofservice">Terms of Service</Link></li>
                  </ul>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
        <div className="footer-bot">
          <Container> 
            <Row>
              <Col md={12}>
                <div className="copyright">© Copyright {currentYear} Blue Starling Corp. All rights reserved. Registered with FINTRAC Reg. No. M20666701</div>
              </Col>
            </Row>
          </Container>
        </div>
      </footer>
    </>
  )
}

export default Footer